<section class="mb-lg-6 overflow-hidden" [class.mt-5]="minimal()" appAos>
    <div class="container scroller" #scroller data-speed="fast">
        @if (!minimal()) {
        <div class="row mb-5 mt-4 mt-lg-6">
            <div class="col text-center">
                <p class="heading color-grey-medium mb-0">Unsere Partnerunternehmen</p>
            </div>
        </div>
        }
        <div class="row tag-list scroller-inner" [class.stop-animation]="body()?.items?.length">
            @if (body()?.items?.length) { @for (trustElement of body()?.items; track trustElement; let i = $index) {
            <div class="col-3 col-lg-2 gx-md-6 d-flex justify-content-center logo-item">
                <img [src]="trustElement?.logo?.url" [alt]="trustElement?.logo?.alt" [title]="trustElement?.logo?.alt" />
            </div>
            } } @else { @for (trustElement of (globalContent?.logos); track trustElement; let i = $index) {
            <div class="col-3 col-lg-2 gx-md-6 d-flex justify-content-center logo-item">
                <img [src]="trustElement?.logo?.url" [alt]="trustElement?.logo?.alt" [title]="trustElement?.logo?.alt" />
            </div>
            } }
        </div>

        <div class="row mt-4">
            <div class="col">
                @if (!minimal()) {
                <hr />
                }
            </div>
        </div>
    </div>
</section>
